import React, { useReducer } from 'react'
import ShipStationContext from './shipStationContext'
import ShipStationReducer from './shipStationReducer'
import { apiCall } from '../../../../common/api'
import { response } from '../../../common'

import {
    GET_ALL_WAREHOUSES,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './shipStationTypes'

const ShipStationState = (props) => {
    const initialState = {
        responseStatus: null,
        all_warehouses: {
            records: [],
        },
    }

    const [state, dispatch] = useReducer(ShipStationReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllWarehouse = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllWarehouse',
                    formData,
                    '',
                    'third_party/shipping/shipstation'
                ),
            ])
            const from = 'getAllWarehouse'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_WAREHOUSES,
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <ShipStationContext.Provider
            value={{
                all_warehouses: state.all_warehouses,
                clearResponse,
                getAllWarehouse,
            }}
        >
            {props.children}
        </ShipStationContext.Provider>
    )
}

export default ShipStationState
